import leeWhitwellGripsPink from '@/assets/lee-whitwell-grips-pink.webp';
import leeWhitwellGripsGreen from '@/assets/lee-whitwell-grips-green.webp';
import signatureTshirtBlack from '@/assets/signature-tshirt-black.png';

export interface Product {
  id: string;
  name: string;
  styleNumber: string;
  price: number;
  image: string;
  colors: string[];
  category: 'grips' | 'apparel' | 'accessories' | 'spray';
  collection: 'pro-tour' | 'xtreme-tack' | 'gradient' | 'standard' | 'signature';
  gripType?: 'comfort' | 'dry-feel' | 'gradient' | 'xtreme-tacky' | 'signature';
  isNew: boolean;
  isBestSeller: boolean;
  rating: number;
  description: string;
}

export const products: Product[] = [
  // Comfort Grips
  {
    id: 'cf-001',
    name: 'Comfort Pro Grip',
    styleNumber: 'GRZ-CF-001',
    price: 22.99,
    image: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#282828', '#FFFFFF', '#4ECDC4'],
    category: 'grips',
    collection: 'standard',
    gripType: 'comfort',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Plush cushioning for extended play sessions without hand fatigue.',
  },
  {
    id: 'cf-002',
    name: 'Comfort Elite',
    styleNumber: 'GRZ-CF-002',
    price: 26.99,
    image: 'https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320', '#1E90FF'],
    category: 'grips',
    collection: 'pro-tour',
    gripType: 'comfort',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Premium memory foam core with moisture-wicking surface.',
  },
  {
    id: 'cf-003',
    name: 'Comfort Max',
    styleNumber: 'GRZ-CF-003',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=600&h=600&fit=crop',
    colors: ['#FFFFFF', '#282828', '#FF6B6B'],
    category: 'grips',
    collection: 'standard',
    gripType: 'comfort',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Maximum thickness for ultimate shock absorption.',
  },
  {
    id: 'cf-004',
    name: 'Comfort Tour',
    styleNumber: 'GRZ-CF-004',
    price: 28.99,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop',
    colors: ['#4ECDC4', '#282828', '#C8E320'],
    category: 'grips',
    collection: 'pro-tour',
    gripType: 'comfort',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Tour-level comfort with professional-grade durability.',
  },

  // Dry Feel Grips
  {
    id: 'df-001',
    name: 'Dry Feel Original',
    styleNumber: 'GRZ-DF-001',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320', '#FFFFFF'],
    category: 'grips',
    collection: 'standard',
    gripType: 'dry-feel',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Advanced moisture-wicking technology keeps your hands dry.',
  },
  {
    id: 'df-002',
    name: 'Dry Feel Pro',
    styleNumber: 'GRZ-DF-002',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=600&h=600&fit=crop',
    colors: ['#1E90FF', '#282828', '#FFFFFF'],
    category: 'grips',
    collection: 'pro-tour',
    gripType: 'dry-feel',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Professional-grade sweat absorption for intense matches.',
  },
  {
    id: 'df-003',
    name: 'Dry Feel Ultra',
    styleNumber: 'GRZ-DF-003',
    price: 27.99,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#282828', '#4ECDC4'],
    category: 'grips',
    collection: 'standard',
    gripType: 'dry-feel',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Ultra-dry surface texture for sweaty palms.',
  },
  {
    id: 'df-004',
    name: 'Dry Feel Elite',
    styleNumber: 'GRZ-DF-004',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=600&h=600&fit=crop',
    colors: ['#FFFFFF', '#282828', '#FF6B6B'],
    category: 'grips',
    collection: 'pro-tour',
    gripType: 'dry-feel',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Elite-level moisture control for tournament play.',
  },

  // Gradient Grips
  {
    id: 'gd-001',
    name: 'Sunset Gradient Grip',
    styleNumber: 'GRZ-GD-001',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop',
    colors: ['gradient-sunset'],
    category: 'grips',
    collection: 'gradient',
    gripType: 'gradient',
    isNew: true,
    isBestSeller: false,
    rating: 4,
    description: 'Stand out on the court with our stunning sunset gradient design.',
  },
  {
    id: 'gd-002',
    name: 'Ocean Wave Gradient',
    styleNumber: 'GRZ-GD-002',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=600&h=600&fit=crop',
    colors: ['gradient-ocean'],
    category: 'grips',
    collection: 'gradient',
    gripType: 'gradient',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Cool blue gradient inspired by ocean waves.',
  },
  {
    id: 'gd-003',
    name: 'Neon Flash Gradient',
    styleNumber: 'GRZ-GD-003',
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?w=600&h=600&fit=crop',
    colors: ['gradient-neon'],
    category: 'grips',
    collection: 'gradient',
    gripType: 'gradient',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Electric neon gradient for maximum visibility.',
  },
  {
    id: 'gd-004',
    name: 'Forest Fade Gradient',
    styleNumber: 'GRZ-GD-004',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=600&h=600&fit=crop',
    colors: ['gradient-forest'],
    category: 'grips',
    collection: 'gradient',
    gripType: 'gradient',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Natural green gradient for an earthy aesthetic.',
  },

  // Xtreme Tacky Grips
  {
    id: 'xt-001',
    name: 'XTREME Tack Grip',
    styleNumber: 'GRZ-XT-001',
    price: 27.99,
    image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=600&h=600&fit=crop',
    colors: ['#FF6B6B', '#282828', '#C8E320'],
    category: 'grips',
    collection: 'xtreme-tack',
    gripType: 'xtreme-tacky',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Ultra-tacky formula for players who demand the best.',
  },
  {
    id: 'xt-002',
    name: 'XTREME Pro Tack',
    styleNumber: 'GRZ-XT-002',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=600&h=600&fit=crop',
    colors: ['#282828', '#FF6B6B', '#C8E320'],
    category: 'grips',
    collection: 'xtreme-tack',
    gripType: 'xtreme-tacky',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Professional-level tackiness that lasts all match.',
  },
  {
    id: 'xt-003',
    name: 'XTREME Sticky Max',
    styleNumber: 'GRZ-XT-003',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#282828', '#FF6B6B'],
    category: 'grips',
    collection: 'xtreme-tack',
    gripType: 'xtreme-tacky',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Maximum stickiness for ultimate paddle control.',
  },
  {
    id: 'xt-004',
    name: 'XTREME Tour Tack',
    styleNumber: 'GRZ-XT-004',
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop',
    colors: ['#1E90FF', '#282828', '#FF6B6B'],
    category: 'grips',
    collection: 'xtreme-tack',
    gripType: 'xtreme-tacky',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Tournament-approved extreme tackiness.',
  },

  // Lee Whitwell Signature Collection
  {
    id: 'lw-001',
    name: 'Lee Whitwell Signature 12-Pack - Neon Pink',
    styleNumber: 'GRZ-LW-001',
    price: 24.99,
    image: leeWhitwellGripsPink,
    colors: ['#FF1493'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Pro Tour formula with enhanced sweat absorption and superior tackiness.',
  },
  {
    id: 'lw-002',
    name: 'Lee Whitwell Signature 12-Pack - Lime Green',
    styleNumber: 'GRZ-LW-002',
    price: 24.99,
    image: leeWhitwellGripsGreen,
    colors: ['#32CD32'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Electric lime green with championship-level quality and comfort.',
  },
  {
    id: 'lw-003',
    name: 'Lee Whitwell Signature 12-Pack - Ocean Blue',
    styleNumber: 'GRZ-LW-003',
    price: 24.99,
    image: leeWhitwellGripsPink,
    colors: ['#1E90FF'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Ocean blue for cool court confidence.',
  },
  {
    id: 'lw-004',
    name: 'Lee Whitwell Signature 12-Pack - Sunset Orange',
    styleNumber: 'GRZ-LW-004',
    price: 24.99,
    image: leeWhitwellGripsGreen,
    colors: ['#FF6B35'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Sunset orange for bold court presence.',
  },
  {
    id: 'lw-005',
    name: 'Lee Whitwell Signature 12-Pack - Electric Purple',
    styleNumber: 'GRZ-LW-005',
    price: 24.99,
    image: leeWhitwellGripsPink,
    colors: ['#9B30FF'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Electric purple for standout style.',
  },
  {
    id: 'lw-006',
    name: 'Lee Whitwell Signature 12-Pack - Classic Black',
    styleNumber: 'GRZ-LW-006',
    price: 24.99,
    image: leeWhitwellGripsGreen,
    colors: ['#282828'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Classic black for timeless performance.',
  },
  {
    id: 'lw-007',
    name: 'Lee Whitwell Signature 12-Pack - Turquoise',
    styleNumber: 'GRZ-LW-007',
    price: 24.99,
    image: leeWhitwellGripsPink,
    colors: ['#40E0D0'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Turquoise for tropical vibes on court.',
  },
  {
    id: 'lw-008',
    name: 'Lee Whitwell Signature 12-Pack - Hot Red',
    styleNumber: 'GRZ-LW-008',
    price: 24.99,
    image: leeWhitwellGripsGreen,
    colors: ['#FF0000'],
    category: 'grips',
    collection: 'signature',
    gripType: 'signature',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Lee Whitwell signature 12-pack overgrips. Hot red for fiery competition.',
  },

  // Pro Tour Grips (legacy)
  {
    id: 'pt-001',
    name: 'Pro Tour Grip',
    styleNumber: 'GRZ-PT-001',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#282828', '#FFFFFF', '#FF6B6B', '#4ECDC4'],
    category: 'grips',
    collection: 'pro-tour',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Our flagship grip used by professional players worldwide.',
  },
  {
    id: 'pt-002',
    name: 'Pro Tour Elite',
    styleNumber: 'GRZ-PT-002',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1526888935184-a82d2a4b7e67?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#282828', '#1E90FF'],
    category: 'grips',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Enhanced tackiness for maximum control in all conditions.',
  },
  {
    id: 'ap-001',
    name: 'Grizzlee Team Tee',
    styleNumber: 'GRZ-AP-001',
    price: 34.99,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&h=600&fit=crop',
    colors: ['#282828', '#FFFFFF', '#C8E320'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Premium cotton tee with embroidered Grizzlee logo.',
  },
  {
    id: 'ap-002',
    name: 'Performance Cap',
    styleNumber: 'GRZ-AP-002',
    price: 28.99,
    image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320'],
    category: 'apparel',
    collection: 'standard',
    isNew: true,
    isBestSeller: false,
    rating: 4,
    description: 'Breathable performance cap with moisture-wicking band.',
  },
  {
    id: 'ap-003',
    name: 'Pro Tour Polo',
    styleNumber: 'GRZ-AP-003',
    price: 54.99,
    image: 'https://images.unsplash.com/photo-1625910513413-5fc42e80dd51?w=600&h=600&fit=crop',
    colors: ['#282828', '#FFFFFF', '#1E90FF'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Tournament-ready polo with moisture-wicking performance fabric.',
  },
  {
    id: 'ap-004',
    name: 'Grip Culture Hoodie',
    styleNumber: 'GRZ-AP-004',
    price: 32.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Black_Hoodie_Neon_Pink_3D_Mockup.png?v=1739516195&width=3840',
    colors: ['#282828', '#FF69B4', '#FFFFFF'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Premium heavyweight hoodie with neon pink Grizzlee Gripz branding. Perfect for on and off the court.',
  },
  {
    id: 'ap-009',
    name: 'Elevate Your Game Crewneck',
    styleNumber: 'GRZ-AP-009',
    price: 38.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/black_sweatshirt_elevate_your_game.png?v=1739516293&width=3840',
    colors: ['#282828', '#FFFFFF', '#C8E320'],
    category: 'apparel',
    collection: 'standard',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Soft crewneck sweatshirt with colorful Elevate Your Game logo. Premium cotton fleece.',
  },
  {
    id: 'ap-010',
    name: 'Pro Tour Signature Hoodie',
    styleNumber: 'GRZ-AP-010',
    price: 32.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Grizzlee_Gripz_Black_Signature_Hoodie.webp?v=1763591298&width=3840',
    colors: ['#282828', '#FFFFFF'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Premium black signature hoodie with embroidered Grizzlee Gripz logo. Official Team Grizzlee wear.',
  },
  {
    id: 'ap-011',
    name: 'Signature White Label Crewneck',
    styleNumber: 'GRZ-AP-011',
    price: 42.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Black_Crewneck_White_Signature-Grizzlee-Gripz.jpg?v=1741980649&width=3840',
    colors: ['#282828', '#FFFFFF'],
    category: 'apparel',
    collection: 'standard',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Classic black crewneck with signature white Grizzlee Gripz logo. Cozy and stylish for pickleball athletes.',
  },
  {
    id: 'ap-012',
    name: 'No Grip Slippin Crewneck',
    styleNumber: 'GRZ-AP-012',
    price: 42.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/black_no_grip_slippin_crewneck_front.jpg?v=1739516863&width=3840',
    colors: ['#282828', '#FFD700', '#8B4513', '#4B0082'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: "Don't let the grip slip! Premium crewneck with bold graphic design. Available in multiple colors.",
  },
  {
    id: 'ap-005',
    name: 'Court Ready Tank',
    styleNumber: 'GRZ-AP-005',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=600&h=600&fit=crop',
    colors: ['#FFFFFF', '#282828', '#C8E320'],
    category: 'apparel',
    collection: 'standard',
    isNew: true,
    isBestSeller: false,
    rating: 4,
    description: 'Lightweight performance tank for intense matches.',
  },
  {
    id: 'ap-006',
    name: 'Signature Visor',
    styleNumber: 'GRZ-AP-006',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1575428652377-a2d80e2277fc?w=600&h=600&fit=crop',
    colors: ['#FFFFFF', '#282828'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Classic visor with adjustable strap and sweat-wicking band.',
  },
  {
    id: 'ap-007',
    name: 'XTREME Performance Tee',
    styleNumber: 'GRZ-AP-007',
    price: 44.99,
    image: 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&h=600&fit=crop',
    colors: ['#FF6B6B', '#282828', '#FFFFFF'],
    category: 'apparel',
    collection: 'xtreme-tack',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Tech fabric tee with reflective XTREME branding.',
  },
  {
    id: 'ap-008',
    name: 'Warm-Up Jacket',
    styleNumber: 'GRZ-AP-008',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Lightweight warm-up jacket with zip pockets and ventilation.',
  },
  // T-Shirts Collection
  {
    id: 'ts-001',
    name: 'Grizzlee Gripz | Signature T-shirt',
    styleNumber: 'GRZ-TS-001',
    price: 26.00,
    image: signatureTshirtBlack,
    colors: ['#282828'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Elevate your game on and off the court with the Grizzlee Gripz Soft Ring-Spun Pickleball T-Shirt. Made from ultra-soft, 100% combed and ring-spun cotton with lightweight 4.2 oz./yd² breathable fabric. Durable, pre-shrunk, and featuring bold Grizzlee Gripz branding.',
  },
  {
    id: 'ts-002',
    name: 'Neon Green Signature Grizzly Bear T-Shirt',
    styleNumber: 'GRZ-TS-002',
    price: 26.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Signature_Neon_Green_Black_T-Shirt.png?v=1739516737&width=3840',
    colors: ['#282828', '#C8E320', '#FF69B4'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Bold neon green signature with pink grizzly bear graphic on premium black tee.',
  },
  {
    id: 'ts-003',
    name: 'On Court Playing T-Shirt Performance',
    styleNumber: 'GRZ-TS-003',
    price: 32.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Grizzlee_Gripz_Iconic_Spine_Logo_Court_T-shirt_for_Pickleball_Players.png?v=1741973163&width=3840',
    colors: ['#282828', '#1E3A8A', '#4169E1'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Iconic spine logo court t-shirt. Polyester mesh for breathability during intense play.',
  },
  {
    id: 'ts-004',
    name: 'Grizzlee Gripz Signature Green T-Shirt',
    styleNumber: 'GRZ-TS-004',
    price: 26.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Forest_Green_Branding_black_t-shirt.png?v=1739516096&width=3840',
    colors: ['#282828', '#228B22'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Forest green branding on black performance t-shirt. Ultra-soft and moisture-wicking.',
  },
  {
    id: 'ts-005',
    name: 'Punk Rock Grizzly Bear T-Shirt',
    styleNumber: 'GRZ-TS-005',
    price: 26.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Black_t-shirt_Punk_rock_Grizzly.jpg?v=1735800055&width=3840',
    colors: ['#282828', '#8B00FF', '#A9A9A9', '#87CEEB'],
    category: 'apparel',
    collection: 'xtreme-tack',
    isNew: false,
    isBestSeller: false,
    rating: 5,
    description: 'Stylish punk rock grizzly bear graphic. Bold, bright colors on premium cotton.',
  },
  {
    id: 'ts-006',
    name: 'In or Out Breathable Court T-Shirt',
    styleNumber: 'GRZ-TS-006',
    price: 32.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/grizzlee_gripz_black_court_lines_playing_shirt.jpg?v=1732058774&width=3840',
    colors: ['#282828', '#1E3A8A'],
    category: 'apparel',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Breathable court shirt with green and white court lines logo. Made for performance.',
  },
  {
    id: 'ts-007',
    name: 'Navy Blue Court Lines T-Shirt',
    styleNumber: 'GRZ-TS-007',
    price: 32.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/navy_blue_court_lines_playing_shirt.jpg?v=1735279572&width=3840',
    colors: ['#1E3A8A', '#C8E320', '#FFFFFF'],
    category: 'apparel',
    collection: 'standard',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Navy blue breathable court shirt with signature court lines design.',
  },
  {
    id: 'ts-008',
    name: 'Purple Punk Rock Grizzly T-Shirt',
    styleNumber: 'GRZ-TS-008',
    price: 26.00,
    image: 'https://www.grizzleegripz.com/cdn/shop/files/Purple_Punk_Rock_Grizzly_Bear_T-shirt.jpg?v=1735800076&width=3840',
    colors: ['#8B00FF', '#FF69B4', '#00CED1'],
    category: 'apparel',
    collection: 'xtreme-tack',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Purple punk rock grizzly bear tee with vibrant color graphics.',
  },

  // Grip Enhancers (Sprays)
  {
    id: 'sp-001',
    name: 'GRIP PRO Tacky Grip Spray for Sweaty Hands',
    styleNumber: 'GRZ-GP-001',
    price: 14.95,
    image: 'https://cdn.shopify.com/s/files/1/0564/6100/0837/files/New_Grizzlee_Gripz_Grip_Pro_Bottle_Bundle_Cutout.webp?v=1758134209',
    colors: [],
    category: 'spray',
    collection: 'pro-tour',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Tacky grip spray for sweaty hands with GripX Technology. Made with 100% USA Pine Gum Rosin and jojoba oil for comfortable, long-lasting grip.',
  },
  {
    id: 'sp-002',
    name: 'GRIP PRO Tacky Grip Spray — 2-Pack',
    styleNumber: 'GRZ-GP-002',
    price: 26.00,
    image: 'https://cdn.shopify.com/s/files/1/0564/6100/0837/files/New_Grizzlee_Gripz_Grip_Pro_Bottle_Bundle_Cutout.webp?v=1758134209',
    colors: [],
    category: 'spray',
    collection: 'pro-tour',
    isNew: false,
    isBestSeller: false,
    rating: 5,
    description: 'Save on two bottles of GRIP PRO Tacky Grip Spray. Perfect for keeping one at home and one in your gear bag.',
  },
  {
    id: 'sp-003',
    name: 'GRIP PRO Tacky Grip Spray — 3-Pack',
    styleNumber: 'GRZ-GP-003',
    price: 26.00,
    image: 'https://cdn.shopify.com/s/files/1/0564/6100/0837/files/New_Grizzlee_Gripz_Grip_Pro_Bottle_Bundle_Cutout.webp?v=1758134209',
    colors: [],
    category: 'spray',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: true,
    rating: 5,
    description: 'Three bottles of GRIP PRO Tacky Grip Spray for sweaty hands. Free US shipping on orders $50+.',
  },
  {
    id: 'sp-004',
    name: 'COURT PRO Performance Spray',
    styleNumber: 'GRZ-CP-001',
    price: 16.95,
    image: 'https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=600&h=600&fit=crop',
    colors: [],
    category: 'spray',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Court-specific grip enhancer designed for indoor and outdoor play. Quick-dry formula with enhanced tackiness.',
  },
  {
    id: 'sp-005',
    name: 'COURT PRO 2-Pack',
    styleNumber: 'GRZ-CP-002',
    price: 29.95,
    image: 'https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=600&h=600&fit=crop',
    colors: [],
    category: 'spray',
    collection: 'pro-tour',
    isNew: true,
    isBestSeller: false,
    rating: 5,
    description: 'Two bottles of COURT PRO for serious players. Keep your grip consistent match after match.',
  },
  {
    id: 'ac-001',
    name: 'Grip Overgrip Pack',
    styleNumber: 'GRZ-AC-001',
    price: 14.99,
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=600&h=600&fit=crop',
    colors: ['#C8E320', '#FF6B6B', '#4ECDC4', '#282828'],
    category: 'accessories',
    collection: 'standard',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Pack of 3 premium overgrips in assorted colors.',
  },
  {
    id: 'ac-002',
    name: 'Paddle Edge Guard',
    styleNumber: 'GRZ-AC-002',
    price: 12.99,
    image: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320', '#FFFFFF'],
    category: 'accessories',
    collection: 'standard',
    isNew: false,
    isBestSeller: true,
    rating: 5,
    description: 'Protect your paddle edge from scrapes and dings.',
  },
  {
    id: 'ac-003',
    name: 'Pro Wristband Set',
    styleNumber: 'GRZ-AC-003',
    price: 16.99,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=600&fit=crop',
    colors: ['#282828', '#C8E320', '#FFFFFF', '#FF6B6B'],
    category: 'accessories',
    collection: 'standard',
    isNew: true,
    isBestSeller: false,
    rating: 4,
    description: 'Moisture-wicking wristbands with embroidered logo. Set of 2.',
  },
  {
    id: 'ac-004',
    name: 'Grip Cleaning Kit',
    styleNumber: 'GRZ-AC-004',
    price: 22.99,
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=600&h=600&fit=crop',
    colors: [],
    category: 'accessories',
    collection: 'standard',
    isNew: false,
    isBestSeller: false,
    rating: 4,
    description: 'Keep your grip fresh with our specialized cleaning solution and cloth.',
  },
];

import teamLeeWhitwell from '@/assets/team-lee-whitwell.webp';
import teamJamesDelgadoAsset from '@/assets/team-james-delgado-new.png.asset.json';
const teamJamesDelgado = teamJamesDelgadoAsset.url;
import teamShayHugo from '@/assets/team-shay-hugo.png.asset.json';
import teamLiamDuffin from '@/assets/team-liam-duffin.webp';
import teamEdwardPerez from '@/assets/team-edward-perez.webp';
import teamLukeWasson from '@/assets/team-luke-wasson.webp';
import teamZachGonnering from '@/assets/team-zach-gonnering.webp';
import teamAustinMireles from '@/assets/team-austin-mireles.webp';

export const athletes = [
  {
    id: 'ath-001',
    name: 'Lee Whitwell',
    title: 'Team Grizzlee',
    image: teamLeeWhitwell,
    testimonial: 'I absolutely love the grips. The grip performance is phenomenal!',
  },
  {
    id: 'ath-002',
    name: 'James Delgado',
    title: 'Team Grizzlee',
    image: teamJamesDelgado,
    testimonial: 'The quality and tackiness are just perfect. Never going back.',
  },
  {
    id: 'ath-003',
    name: 'Shay Hugo',
    title: 'Team Grizzlee',
    image: teamShayHugo.url,
    testimonial: 'The quality is beyond expectations, and I found it with the White Pro Tour grips',
  },
  {
    id: 'ath-004',
    name: 'Liam Duffin',
    title: 'Team Grizzlee',
    image: teamLiamDuffin,
    testimonial: 'These grips are hands-down my favorite I\'ve ever played with.',
  },
  {
    id: 'ath-005',
    name: 'Edward Perez',
    title: 'Team Grizzlee',
    image: teamEdwardPerez,
    testimonial: 'Grizzlee Gripz is changing the game with premium material I trust.',
  },
  {
    id: 'ath-006',
    name: 'Luke Wasson',
    title: 'Team Grizzlee',
    image: teamLukeWasson,
    testimonial: 'Coming from Golf, a secure grip is very important. Love the brand!',
  },
  {
    id: 'ath-007',
    name: 'Zach Gonnering',
    title: 'Team Grizzlee',
    image: teamZachGonnering,
    testimonial: 'Colors do not change the quality or tackiness. Premium feel 100%',
  },
  {
    id: 'ath-008',
    name: 'Austin Mireles',
    title: 'Team Grizzlee',
    image: teamAustinMireles,
    testimonial: 'The tackiness is next-level—gives me a secure hold in every session.',
  },
];
